var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 -2.78158e-06C17.523 -2.29874e-06 22 4.477 22 10C22 15.523 17.523 20 12 20C10.4473 20.0012 8.91581 19.6402 7.52707 18.9459C6.13833 18.2515 4.93066 17.2428 4 16L6.71 16C7.86477 17.0182 9.28883 17.6816 10.8113 17.9106C12.3337 18.1396 13.8899 17.9243 15.2931 17.2908C16.6963 16.6572 17.8869 15.6322 18.7219 14.3388C19.557 13.0454 20.0011 11.5385 20.001 9.99889C20.0009 8.45931 19.5565 6.95247 18.7212 5.65918C17.8859 4.3659 16.6952 3.3411 15.2919 2.70778C13.8886 2.07446 12.3324 1.8595 10.81 2.08871C9.28755 2.31793 7.8636 2.98156 6.709 4L3.999 4C4.92976 2.75704 6.13759 1.74829 7.52652 1.05391C8.91544 0.359538 10.4472 -0.00132471 12 -2.78158e-06ZM5 6L5 9L13 9L13 11L5 11L5 14L8.74228e-07 10L5 6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.1afeb247216251fd5807606d1178f124.svg";
export { ForwardRef as ReactComponent };